module.exports = __webpack_public_path__ + "static/media/cchat-logo-icon.e7d6bd5b.svg";